import React, { useContext, useState } from 'react';
import './Navbar.css';
import logo from '../Assets/logo.png';
import cart_icon from '../Assets/cart_icon.png';
import { Link } from 'react-router-dom';
import { ShopContext } from '../../Context/ShopContext';

const Navbar = () => {

  const [menu, setMenu] = useState("shop");
  const [mobileMenu, setMobileMenu] = useState(false);

  const { cartItems } = useContext(ShopContext);

  const getTotalCartItems = () => {
    let totalItems = 0;

    for (const item in cartItems) {
      totalItems += cartItems[item];
    }

    return totalItems;
  };

  const handleMenuClick = (menuName) => {
    setMenu(menuName);
    setMobileMenu(false);
  };

  return (
    <div className="navbar">

      {/* Logo */}
      <div className="nav-logo">
        <img src={logo} alt="Logo" />
        <p>SHOPPER</p>
      </div>


      {/* Mobile Menu Button */}
      <button
        className="mobile-menu-btn"
        onClick={() => setMobileMenu(!mobileMenu)}
      >
        ☰
      </button>


      {/* Navigation Menu */}
      <ul className={`nav-menu ${mobileMenu ? "nav-menu-active" : ""}`}>

        <li onClick={() => handleMenuClick("shop")}>
          <Link to="/">Shop</Link>
          {menu === "shop" && <hr />}
        </li>

        <li onClick={() => handleMenuClick("mens")}>
          <Link to="/mens">Men</Link>
          {menu === "mens" && <hr />}
        </li>

        <li onClick={() => handleMenuClick("womens")}>
          <Link to="/womens">Women</Link>
          {menu === "womens" && <hr />}
        </li>

        <li onClick={() => handleMenuClick("kids")}>
          <Link to="/kids">Kids</Link>
          {menu === "kids" && <hr />}
        </li>

      </ul>


      {/* Login + Cart */}
      <div className="nav-login-cart">

        <Link to="/login" onClick={() => setMobileMenu(false)}>
          <button>Login</button>
        </Link>

        <Link to="/cart" onClick={() => setMobileMenu(false)}>
          <img src={cart_icon} alt="Cart" />
          <div className="nav-cart-count">
            {getTotalCartItems()}
          </div>
        </Link>

      </div>

    </div>
  );
};

export default Navbar;